import { Badge } from '@/components/ui/badge';

interface UserStatusBadgeProps {
  enabled: boolean;
}

export function UserStatusBadge({ enabled }: UserStatusBadgeProps) {
  if (enabled) {
    return (
      <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
        Enabled
      </Badge>
    );
  }

  return (
    <Badge variant="outline" className="bg-gray-50 text-gray-600 border-gray-200">
      Disabled
    </Badge>
  );
}
